import * as React from 'react'
import { observer } from 'mobx-react'
import { useRouteMatch } from 'react-router-dom'
import {
  SplitViewSidebarListItem,
  SplitViewSidebarListItemArrow,
  SplitViewSidebarListItemTitle,
  SplitViewSidebarListItemSubtitle,
} from 'components/SplitView'

interface NavItemProps extends React.HTMLAttributes<HTMLDivElement> {
  to: string
  title: string
  children: React.ReactNode
}

export default observer(function NavItem({
  to,
  title,
  children,
}: NavItemProps) {
  const active = Boolean(useRouteMatch(to))
  return (
    <SplitViewSidebarListItem
      to={to}
      active={active}
      extras={<SplitViewSidebarListItemArrow />}
    >
      <SplitViewSidebarListItemTitle>{title}</SplitViewSidebarListItemTitle>
      <SplitViewSidebarListItemSubtitle>
        {children}
      </SplitViewSidebarListItemSubtitle>
    </SplitViewSidebarListItem>
  )
})
